import React from 'react'

const CircleCheck = props => (
  <svg width='1em' height='1em' viewBox='0 0 15 15' {...props}>
    <path d='M7.5 0A7.5 7.5 0 0 0 0 7.5 7.5 7.5 0 0 0 7.5 15 7.5 7.5 0 0 0 15 7.5 7.5 7.5 0 0 0 7.5 0zm3.117 4.984a.5.5 0 0 1 .395.846l-4.438 4.772a.5.5 0 0 1-.75-.02L4.115 8.537a.5.5 0 1 1 .77-.64l1.344 1.609 4.05-4.358a.5.5 0 0 1 .338-.164z' />
  </svg>
)

export default CircleCheck
